import * as React from 'react';
import Box from '@mui/material/Box';

export default function WomappLogo() {
  return (
    <Box
      component='img'
      src='/main-white.svg'
      alt='Word of Mouth LTD'
      sx={{
        height: { xs: 40, tablet: 48 },
        width: 'auto',
        mr: 1,
        display: 'block',
        filter:
          'brightness(0) saturate(100%) invert(81%) sepia(82%) saturate(2456%) hue-rotate(143deg) brightness(103%) contrast(106%)', // Cyan color #00FFFF
      }}
    />
  );
}
